import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { convertToBriefingResourceReq } from '@/util/ds-util';
import BriefingService from '@/service/briefing.service';
import AskGooverService from '@/service/ask-goover.service';
import { removeUnUsedSpace } from '@/util/string.util';
import type { LoadingDataByType, LoadingDataReportCard, ToastReportData } from '@/shared/model/briefing-resource.model';
import {
  CONTENT_TYPE_MY_CONTENT,
  CREATE_PODCAST,
  DATA_SOURCE_CHAT,
  DOCUMENT_TYPE_REPORT,
  GOOVER_WIDZAD,
  LOADING_DATA_TYPE,
  MEDIA_LOADING_DATA_TYPE,
  MEDIA_TYPES,
  REPORT_STYLES,
  PRIVACY_TYPES,
  REPORT_TOAST_STATUS,
  REPORT_TOAST_STATUS_CODE,
  REPORT_TYPES,
  ROLE_CHAT,
  SAVE_TYPE_REPORT,
  TIME_DISPLAY_SUCCESS_TOAST_REPORT,
  TIME_OUT_ALL_LOADING_CREATE,
} from '@/constants';
import LoadingReportCardUtil from '@/util/loading-report-card.util';
import ReportToastUtil from '@/util/report-toast.util';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import BriefingListView from '@/entities/briefing/briefing-list-view/briefing-list-view.vue';
import popupDeleteBriefingComponent from '@/entities/briefing/popup-delete-briefing/popup-delete-briefing.component';
import { formatDateAgo } from '../../../util/date-util';
import { formattedDate } from '../../../entities/article-detail/artical-common';
import moment from 'moment';
import { makeReportTypeText } from '@/util/common-util';
import { isPaidUser } from '@/util/paid-user-util';
import { checkIsGuestAccount } from '@/util/guest-util';
import ScrapAgentModal from '@/entities/scrap-agent/scrap-agent.vue';
import RecapService from '@/service/recap.service';
import { map2ResourceItem } from '@/util/mapper-utils';

const appStoreState = namespace('appStore');
const briefingStore = namespace('briefingStore');
const askGooverStore = namespace('askGooverStore');

@Component({
  methods: { checkIsGuestAccount, makeReportTypeText, formattedDate, formatDateAgo, isPaidUser },
  mixins: [LoadingReportCardUtil, ReportToastUtil],
  components: {
    popupDeleteBriefingComponent,
    vueCustomScrollbar: vueCustomScrollbar,
    'briefing-list-view': BriefingListView,
    'scrap-agent-modal': ScrapAgentModal,
  },
  computed: {
    ROLE_CHAT() {
      return ROLE_CHAT;
    },
    DATA_SOURCE_CHAT() {
      return DATA_SOURCE_CHAT;
    },
    LOADING_DATA_TYPE() {
      return LOADING_DATA_TYPE;
    },
    moment() {
      return moment;
    },
    isNextDisabled(): boolean {
      if ((!this.selectedTab || this.selectedTab.length == 0) && !this.getIsForNewBriefing) return true;

      if (this.currentTab === this.allSelectTab[5]) {
        if (!this.title || removeUnUsedSpace(this.title)?.length === 0) return true;
        if (!this.dataSource || this.dataSource?.length === 0) return true;
        return this.reportTypesResultForBriefing.includes(this.reportTypes[10]) && this.isReachLimitCreation;
      }

      if (this.currentTab === this.allSelectTab[0]) {
        return this.selectedTab.includes(this.allSelectTab[4]) && this.isReachLimitCreation;
      }

      if (this.currentTab === this.allSelectTab[1]) {
        return this.reportTypesResult.includes(this.reportTypes[10]) && this.isReachLimitCreation;
      }

      return false;
    },
  },
})
export default class ModalCreateAgentComponent extends Vue {
  @Inject() emitGlobalEventShowScrapData!: (payload: any) => void;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  @Inject('askGooverService')
  private askGooverService: () => AskGooverService;

  @Inject('recapService')
  private recapService: () => RecapService;

  @appStoreState.Mutation
  public setShowCreateBriefing!: (isShowCreateBriefing: boolean) => void;

  @briefingStore.Getter
  getReferenceDocuments!: Array<any>;

  @askGooverStore.Getter
  public getConversationId: string;

  @briefingStore.Getter
  public getSelectedBriefingPage!: any;

  @appStoreState.Mutation
  public setDisabledLink!: (payload: any) => void;

  @briefingStore.Mutation
  public setCreateBriefing!: (payload: any) => void;

  @briefingStore.Getter
  public getIsSelectReportNoBriefingTab!: boolean;

  @briefingStore.Getter
  public getIsCreateNewBriefingFromChat!: boolean;

  @briefingStore.Mutation
  public setIsSelectReportNoBriefingTab!: (isSelectReportNoBriefingTab: boolean) => void;

  @appStoreState.Getter
  public getToastReportData!: any;

  @appStoreState.Mutation
  public setToastReportData!: (payload: any) => void;

  @briefingStore.Getter
  public getReferenceDocumentsForNewBriefing!: any[];

  @briefingStore.Getter
  public getIsForNewBriefing!: boolean;

  @briefingStore.Mutation
  public setReferenceDocumentsForNewBriefing!: (payload: any[]) => void;

  @briefingStore.Mutation
  public setIsForNewBriefing!: (payload: boolean) => void;

  @appStoreState.Getter
  getChatSetting!: any;

  @appStoreState.Getter
  getIsCanShowCreateAgent!: boolean;

  @appStoreState.Mutation
  public setIsCanShowCreateAgent!: (payload: boolean) => void;

  @appStoreState.Getter
  public getDataReportNotify!: any;

  @appStoreState.Getter
  public getDataPodcastNotify!: any;

  loadingReportCardUtil = new LoadingReportCardUtil();

  reportToastUtil = new ReportToastUtil();

  title = '';
  description = '';
  privacyTypes = [PRIVACY_TYPES.PUBLIC.toString(), PRIVACY_TYPES.PRIVATE.toString()];
  privacy = this.privacyTypes[0];
  privacyReport = this.privacyTypes[0];
  reportTypes = [
    REPORT_TYPES.DAILY.toString(),
    REPORT_TYPES.PRODUCT_REVIEW.toString(),
    REPORT_TYPES.INVESTMENT.toString(),
    REPORT_TYPES.JOURNAL_NOTE.toString(),
    REPORT_TYPES.DAILY_BLOG.toString(),
    REPORT_TYPES.PRODUCT_REVIEW_BLOG.toString(),
    REPORT_TYPES.INVESTMENT_BLOG.toString(),
    REPORT_TYPES.JOURNAL_NOTE_BLOG.toString(),
    REPORT_TYPES.SOCIAL_MEDIA_BLOG.toString(),
    REPORT_TYPES.DEFAULT.toString(),
    REPORT_TYPES.INDEPTH_DAILY.toString(),
    REPORT_TYPES.SOCIAL_MEDIA_FACEBOOK.toString(),
    REPORT_TYPES.SOCIAL_MEDIA_X.toString(),
    REPORT_TYPES.SOCIAL_MEDIA_YOUTUBE.toString(),
  ];
  optionReportTypes = [REPORT_STYLES.DEFAULT.toString(), REPORT_STYLES.BUSINESS.toString(), REPORT_STYLES.BLOG.toString()];
  isLoading = false;
  isLoadingGenerateData = false;
  tempListTitleMessage = [];
  tempConversationId = '';
  tempListResources = [];
  reportTypesResult = [this.reportTypes[0]];
  reportTypesResultForBriefing = [this.reportTypes[0]];
  isGenerateBriefingPage = false;
  ALL = 'ALL';
  wizardValues = Object.values(GOOVER_WIDZAD) || [];
  allSelectTab: string[] = [this.ALL, ...this.wizardValues];
  // selectedTab: string[] = [this.allSelectTab[5], this.allSelectTab[6]];
  // currentTab = this.allSelectTab[6] || this.allSelectTab[0];
  selectedTab: string[] = [];
  currentTab = this.allSelectTab[0];
  dataSource: string[] = [DATA_SOURCE_CHAT.BASIC.toString()];
  reportTypeSelected = this.reportTypes[0];
  reportTypeSelectedForBriefing = this.reportTypes[0];
  reportStyleSelected = this.optionReportTypes[1];
  reportStyleSelectedForBriefing = this.optionReportTypes[1];
  isShowSelectChat = false;
  listMessageIdsFocus: string[] = [];
  tempCheckedListMessageIdsFocus: string[] = [];
  promptReportFocus = '';
  promptReportFocusForBriefing = '';
  createAgentTypes = [];
  createAgentTypesForRePort = [];
  connectScrapAgentList = [];
  scrapAgentDataList = [];
  isShow = true;
  isDoneGetData = false;
  isDoneGenerateBriefingTitleAndDescription = false;
  enumOrder = {
    [GOOVER_WIDZAD.CREATE_REPORT.toString()]: 0,
    [GOOVER_WIDZAD.JOURNALIST_NOTE.toString()]: 1,
    [GOOVER_WIDZAD.SOCIAL_MEDIA_POSTING.toString()]: 2,
    [GOOVER_WIDZAD.PODCAST.toString()]: 3,
    [GOOVER_WIDZAD.CREATE_BRIEFING_AGENT.toString()]: 4,
    [GOOVER_WIDZAD.CREATE_CONNECT_AGENT.toString()]: 5,
  };
  journalistNoteStyleResult = this.reportTypes[7];
  socialMediaPostingStyleResult = this.reportTypes[8];
  playerProgress = 0;
  audio: HTMLAudioElement = new Audio('');
  totalTime = 0;
  isPlaying = false;
  isMuted = false;
  currentTime = 0;
  hostAudioSelected;
  LOADING_CREATE = {
    REPORT: { isUse: false, isLoading: false, isSuccess: false, requestId: undefined, isTimeOut: false },
    REPORT_BRIEFING: {
      isUse: false,
      isLoading: false,
      isSuccess: false,
      requestId: undefined,
      isTimeOut: false,
    },
    JOURNALIST_NOTE: { isUse: false, isLoading: false, isSuccess: false, requestId: undefined, isTimeOut: false },
    SOCIAL_MEDIA_POSTING: {
      isUse: false,
      isLoading: false,
      isSuccess: false,
      requestId: undefined,
      isTimeOut: false,
    },
    PODCAST: { isUse: false, isLoading: false, isSuccess: false, requestId: undefined, isTimeOut: false },
    SCRAP_AGENT: { isUse: false, isLoading: false, isSuccess: false, isTimeOut: false },
    ALL: { isUse: true, isLoading: true, isSuccess: false, isTimeOut: false },
  };
  originTruncatedIdsList = [];
  truncatedIdsList = [];
  noTruncatedIdsList = [];
  loadingIntervals: { [key: string]: any } = {
    REPORT: null,
    REPORT_BRIEFING: null,
    JOURNALIST_NOTE: null,
    SOCIAL_MEDIA_POSTING: null,
    PODCAST: null,
    briefingAgent: null,
    scrapAgent: null,
  };
  isDataReceived: { [key: string]: boolean } = {
    REPORT: false,
    REPORT_BRIEFING: false,
    JOURNALIST_NOTE: false,
    SOCIAL_MEDIA_POSTING: false,
    PODCAST: false,
    briefingAgent: false,
    scrapAgent: false,
  };
  loadingCount: { [key: string]: number } = {
    REPORT: 0,
    REPORT_BRIEFING: 0,
    JOURNALIST_NOTE: 0,
    SOCIAL_MEDIA_POSTING: 0,
    PODCAST: 0,
    briefingAgent: 0,
    scrapAgent: 0,
  };
  isDisableByScrapModal = true;
  maxLoadingCount = 120;
  podcastHosts = [];
  allHistoryMessages = [];
  timeOutAll = null;
  END_TAB = 'END';
  checkAllItemsCompleteInterval;
  scrapData;
  isCanCreateScrapAgent = false;
  currentPage = 0;
  hostsPerPage = 4;

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  mounted() {
    this.setIsCanShowCreateAgent(true);
    this.tempConversationId = this.getConversationId || '';
    this.reportTypesResult = [this.reportTypes[0]];
    this.reportTypesResultForBriefing = [this.reportTypes[0]];
    this.dataSource = this.getChatSetting?.dataSources || [DATA_SOURCE_CHAT.BASIC.toString()];

    if (this.getIsForNewBriefing) {
      this.selectedTab.push(this.allSelectTab[5]);
    }

    this.getListPodcast();
  }

  beforeDestroy() {
    this.handleKillAll();
  }

  destroyed() {
    this.handleKillAll();
  }

  @Watch('$route')
  onRouteChange() {
    this.handleKillAll();
    this.setShowCreateBriefing(false);
  }

  @Watch('currentTab')
  onCurrentTabChange() {
    try {
      this.$nextTick(() => {
        this.scrollToTop();
      });
    } catch (error) {
      // todo
    }

    if (
      this.currentTab === this.allSelectTab[5] ||
      this.currentTab === this.allSelectTab[1] ||
      this.currentTab === this.allSelectTab[2] ||
      this.currentTab === this.allSelectTab[3] ||
      this.currentTab === this.allSelectTab[4]
    ) {
      this.isLoadingGenerateData = true;

      // console.log('this.currentTab: ', this.currentTab);

      this.getHistory().then(() => {
        this.getBriefingReferenceData().then(() => {
          this.isDoneGetData = true;

          // console.log('this.currentTab === this.allSelectTab[5]: ', this.currentTab === this.allSelectTab[5]);
          if (this.currentTab === this.allSelectTab[5] && !this.isDoneGenerateBriefingTitleAndDescription) {
            this.generateTitleAndSummary().then(() => {
              this.isLoadingGenerateData = false;
              this.isDoneGenerateBriefingTitleAndDescription = true;
            });
          } else {
            this.isLoadingGenerateData = false;
          }
        });
      });
    } else if (this.currentTab === GOOVER_WIDZAD.CREATE_CONNECT_AGENT.toString()) {
      this.getScrapAgentList();
    }
  }

  @Watch('getIsCanShowCreateAgent')
  onGetIsCanShowCreateAgentChange() {
    if (this.getIsCanShowCreateAgent) {
      this.getScrapAgentList();
    }
  }

  @Watch('isShowSelectChat')
  onIsShowSelectChatChange() {
    const temp = [];
    if (this.isShowSelectChat) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.tempListTitleMessage?.forEach((item, index) => {
            let questionId = '';

            if (this.tempListTitleMessage[index] && this.tempListTitleMessage[index].role === ROLE_CHAT.USER.toString()) {
              questionId = 'question_' + item.messageId;
            }

            let answerId1 = '';
            let answerId2 = '';

            if (this.tempListTitleMessage[index + 1] && this.tempListTitleMessage[index + 1].role === ROLE_CHAT.ASSISTANT.toString()) {
              const tempAnswer = this.tempListTitleMessage[index + 1].contentList?.[0];
              answerId1 = 'answer_' + item.messageId + '_' + 0;
              answerId2 = 'answer_' + item.messageId + '_' + 1;
            }

            if (questionId && this.isTruncated(questionId)) {
              temp.push(item.messageId);
            } else if (answerId1 && this.isTruncated(answerId1)) {
              temp.push(item.messageId);
            } else if (answerId2 && this.isTruncated(answerId2)) {
              temp.push(item.messageId);
            }
          });

          this.truncatedIdsList = [...temp];
          this.originTruncatedIdsList = [...temp];
        }, 100);
      });
    }
  }

  @Watch('getDataReportNotify')
  onGetDataReportNotifyChange() {
    if (this.getDataReportNotify !== null) {
      if (
        this.getDataReportNotify &&
        this.getDataReportNotify?.length > 0 &&
        (!this.getDataReportNotify?.status || this.getDataReportNotify?.status !== 'FAIL')
      ) {
        const tempListReportNotify = this.getDataReportNotify
          ?.filter(item => item?.parentDocDetail && (item?.requestId || item?.parentDocDetail?.request_id))
          ?.map(item => ({
            ...item,
            requestId: item?.requestId || item?.parentDocDetail?.request_id || '',
          }))
          ?.filter(item => item.requestId !== undefined && item.requestId !== null && item.requestId !== '')
          ?.map(item => ({
            ...item,
            requestId: item?.requestId.concat(this.reportToastUtil.makeConcatStringByMediaType(item)) || '',
          }))
          ?.filter(item => item.requestId !== undefined && item.requestId !== null && item.requestId !== '')
          .map(item => item.requestId);

        if (tempListReportNotify?.length > 0) {
          tempListReportNotify.forEach(requestId => {
            Object.keys(this.LOADING_CREATE).forEach(key => {
              if (key === this.ALL) return;

              const item = this.LOADING_CREATE[key];

              if (item.requestId === requestId && item.isUse === true && item.isLoading === true && item.isSuccess === false) {
                this.LOADING_CREATE[key] = {
                  ...item,
                  isSuccess: true,
                  isLoading: false,
                };

                if (key in this.isDataReceived) {
                  this.isDataReceived[key] = true;
                }
              }
            });
          });

          this.checkAllItemsComplete();
        }
      }
    }
  }

  @Watch('getDataPodcastNotify')
  onGetDataPodcastNotifyChange() {
    if (this.getDataPodcastNotify !== null && this.getDataPodcastNotify?.requestId?.length > 0) {
      Object.keys(this.LOADING_CREATE).forEach(key => {
        if (key === this.ALL) return;

        const item = this.LOADING_CREATE[key];

        if (
          item.requestId === this.getDataPodcastNotify?.requestId &&
          item.isUse === true &&
          item.isLoading === true &&
          item.isSuccess === false
        ) {
          this.LOADING_CREATE[key] = {
            ...item,
            isSuccess: true,
            isLoading: false,
          };

          if (key in this.isDataReceived) {
            this.isDataReceived[key] = true;
          }
        }
      });

      this.checkAllItemsComplete();
    }
  }

  async getHistory() {
    // just get history when goover from chat and current tab is 1,2,3,4,5
    // two case, get from home chat or modal chat of my create
    // the clause is not good enough, need to handle more

    if (!this.getIsCreateNewBriefingFromChat || this.isDoneGetData) {
      return;
    }

    this.tempConversationId = this.getConversationId || '';
    this.tempListTitleMessage = [];

    if (this.tempConversationId) {
      await this.askGooverService()
        .getConversationById(this.tempConversationId)
        .then(res => {
          if (res.data?.history?.length) {
            this.allHistoryMessages = res?.data?.history || [];

            for (let i = 0; i < res.data.history.length; i++) {
              res.data.history[i]?.messages.forEach(message => {
                let tempContent = [];

                if (message?.role === ROLE_CHAT.USER.toString()) {
                  tempContent = [message?.content || ''];
                } else if (message?.role === ROLE_CHAT.ASSISTANT.toString()) {
                  if (message?.llmContent && message?.llmContent?.length > 0) {
                    const tempContentList = [];

                    message.llmContent.forEach(item => {
                      const tempContentItem = item?.content || '';

                      if (tempContentItem) {
                        tempContentList.push(tempContentItem);
                      }
                    });

                    if (tempContentList?.length > 0) {
                      tempContent = [...tempContentList];
                    }
                  }
                }

                this.tempListTitleMessage.push({
                  role: message.role,
                  contentList: tempContent,
                  messageId: message.messageId,
                });

                this.listMessageIdsFocus.push(message.messageId);
                this.tempCheckedListMessageIdsFocus.push(message.messageId);
              });
            }
          }
        });
    }
  }

  async getBriefingReferenceData() {
    if (this.isDoneGetData) {
      return;
    }
    // console.log('getReferenceDocumentsForNewBriefing: ', ...this.getReferenceDocumentsForNewBriefing);
    this.tempListResources = [];

    if (
      this.getReferenceDocuments &&
      this.getReferenceDocuments.length > 0 &&
      (this.getIsForNewBriefing === undefined || this.getIsForNewBriefing === false) &&
      this.getIsCreateNewBriefingFromChat
    ) {
      const tempReferenceDocuments = this.getReferenceDocuments;
      tempReferenceDocuments.forEach(item => {
        this.tempListResources.push({
          title: item.title || '',
          description: item.description || item.content || '',
        });
      });
    } else if (this.getReferenceDocumentsForNewBriefing?.length > 0) {
      const tempReferenceDocuments = this.getReferenceDocumentsForNewBriefing;

      tempReferenceDocuments.forEach(item => {
        this.tempListResources.push({
          title: item.title || '',
          description: item.description || item.content || '',
        });
      });

      // console.log('tempListResources: ', this.tempListResources);
    }
  }

  async generateTitleAndSummary() {
    try {
      if (
        (this.tempListTitleMessage && this.tempListTitleMessage.length > 0) ||
        (this.tempListResources && this.tempListResources.length > 0)
      ) {
        const tempLanguage =
          this.$i18n.locale || this.userIdentity?.langKey || JSON.parse(localStorage.getItem('localStorageUser'))?.langKey || 'en';

        const tempListTitleMessageSend = [];

        this.tempListTitleMessage.forEach(item => {
          const { contentList, ...itemWithoutContentList } = item;
          tempListTitleMessageSend.push({ ...itemWithoutContentList, content: contentList[0] });
        });

        const response = await this.briefingService().callApiGenerateTitleAndSummary(
          tempListTitleMessageSend,
          tempLanguage,
          this.tempListResources
        );

        if (response?.status === 200 && response?.data.body) {
          this.title = response?.data?.body?.title || '';
          if (this.title && this.title.length > 100) {
            this.title = this.title.slice(0, 100);
          }
          this.description = response?.data?.body?.summary || '';
        }
      }
    } catch (e) {
      // Error handling
    }
  }

  async saveData() {
    if (this.selectedTab.includes(this.allSelectTab[6])) {
      // check if available to create scrap agent
      if (
        this.scrapData &&
        this.scrapData.briefingTitle &&
        this.scrapData.dataSourceAccount?.length > 0 &&
        this.scrapData.dataSourceAccount.some(account => account.dataSources.some(dataSource => dataSource.isScrap === true))
      ) {
        this.LOADING_CREATE.SCRAP_AGENT = { isUse: true, isLoading: true, isSuccess: false, isTimeOut: false };

        // call create scrap agent function in scrap modal
        // @ts-ignore
        this.$refs.scrapAgentModalRef.openModalEnd();

        this.isCanCreateScrapAgent = true;

        // start check to end loading
        this.autoCheckAllItemsComplete();
      }

      // if just create scrap agent then return
      if (this.selectedTab?.length === 1) {
        return;
      }
    }

    // code by Cong
    this.setCreateBriefing(true);

    const userKey = this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
    const lastName = this.userIdentity?.lastName || JSON.parse(localStorage.getItem('localStorageUser'))?.lastName || '';

    const requestId = 'CB-' + Date.now().toString();
    const requestIdCreateReportNoBriefing =
      'CRNBP'.concat('_' + new Date().toISOString()).concat('_' + userKey) || new Date().getTime().toString();

    let bpResourceList = [];
    let conversationId = '';
    let objectMessages = null;
    const loadingDataList: LoadingDataByType[] = [];

    if (this.getIsCreateNewBriefingFromChat) {
      bpResourceList = this.getReferenceDocuments.map(item => item.parentDocId);
      conversationId = this.getConversationId;
    } else {
      bpResourceList = this.getReferenceDocumentsForNewBriefing.map(item => item.parentDocId);
    }

    if (!this.selectedTab.includes(this.allSelectTab[1])) {
      this.reportTypesResult = [];

      this.LOADING_CREATE.REPORT = {
        isUse: false,
        isLoading: false,
        isSuccess: false,
        requestId: undefined,
        isTimeOut: false,
      };
    } else {
      const tempRequestId = requestIdCreateReportNoBriefing.concat('_' + LOADING_DATA_TYPE.REPORT.toString());

      this.LOADING_CREATE.REPORT = {
        isUse: true,
        isLoading: true,
        isSuccess: false,
        requestId: tempRequestId,
        isTimeOut: false,
      };

      loadingDataList.push({ type: LOADING_DATA_TYPE.REPORT.toString(), requestId: tempRequestId });
    }

    if (this.selectedTab.includes(this.allSelectTab[2])) {
      const tempRequestId = requestIdCreateReportNoBriefing.concat('_' + LOADING_DATA_TYPE.JOURNALIST_NOTE.toString());
      this.reportTypesResult.push(this.journalistNoteStyleResult);

      this.LOADING_CREATE.JOURNALIST_NOTE = {
        isUse: true,
        isLoading: true,
        isSuccess: false,
        requestId: tempRequestId,
        isTimeOut: false,
      };

      loadingDataList.push({ type: LOADING_DATA_TYPE.JOURNALIST_NOTE.toString(), requestId: tempRequestId });
    } else {
      this.LOADING_CREATE.JOURNALIST_NOTE = {
        isUse: false,
        isLoading: false,
        isSuccess: false,
        requestId: undefined,
        isTimeOut: false,
      };
    }

    if (this.selectedTab.includes(this.allSelectTab[3])) {
      const tempRequestId = requestIdCreateReportNoBriefing.concat('_' + LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString());
      this.reportTypesResult.push(this.socialMediaPostingStyleResult);

      this.LOADING_CREATE.SOCIAL_MEDIA_POSTING = {
        isUse: true,
        isLoading: true,
        isSuccess: false,
        requestId: tempRequestId,
        isTimeOut: false,
      };

      loadingDataList.push({ type: LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString(), requestId: tempRequestId });
    } else {
      this.LOADING_CREATE.SOCIAL_MEDIA_POSTING = {
        isUse: false,
        isLoading: false,
        isSuccess: false,
        requestId: undefined,
        isTimeOut: false,
      };
    }

    if (this.selectedTab.includes(this.allSelectTab[4])) {
      const tempRequestId = requestIdCreateReportNoBriefing.concat('_' + LOADING_DATA_TYPE.PODCAST.toString());
      // this.reportTypesResult.push(MEDIA_LOADING_DATA_TYPE.PODCAST.toString());

      this.LOADING_CREATE.PODCAST = {
        isUse: true,
        isLoading: true,
        isSuccess: false,
        requestId: tempRequestId,
        isTimeOut: false,
      };

      loadingDataList.push({ type: LOADING_DATA_TYPE.PODCAST.toString(), requestId: tempRequestId });
    } else {
      this.LOADING_CREATE.PODCAST = {
        isUse: false,
        isLoading: false,
        isSuccess: false,
        requestId: undefined,
        isTimeOut: false,
      };
    }

    if (
      this.selectedTab.includes(this.allSelectTab[1]) ||
      this.selectedTab.includes(this.allSelectTab[2]) ||
      this.selectedTab.includes(this.allSelectTab[3]) ||
      this.selectedTab.includes(this.allSelectTab[4])
    ) {
      if (
        this.selectedTab.includes(this.allSelectTab[1]) ||
        this.selectedTab.includes(this.allSelectTab[2]) ||
        this.selectedTab.includes(this.allSelectTab[3])
      ) {
        this.createAgentTypesForRePort.push(GOOVER_WIDZAD.CREATE_REPORT.toString());
      }

      try {
        const briefingResources = [];

        const tempReferenceDocument = this.getIsCreateNewBriefingFromChat
          ? this.getReferenceDocuments
          : this.getReferenceDocumentsForNewBriefing;

        tempReferenceDocument.forEach(item => {
          briefingResources.push(
            convertToBriefingResourceReq(
              item,
              this.$store.getters.userIdentity.id,
              this.$route.name,
              null,
              tempReferenceDocument,
              this.$i18n.locale,
              this.$store.getters?.userIdentity?.lastName,
              requestIdCreateReportNoBriefing,
              false
            )
          );
        });

        // console.log('briefingResources?.[0].requestedResourceList: ', briefingResources?.[0].requestedResourceList);

        const documentMetaInfos = briefingResources?.[0].requestedResourceList?.map(item => ({
          docId: item,
        }));

        let objectPodCast = null;

        if (this.selectedTab.includes(this.allSelectTab[4])) {
          this.createAgentTypesForRePort.push(CREATE_PODCAST.toString());

          if (this.hostAudioSelected) {
            objectPodCast = {
              requestId: requestIdCreateReportNoBriefing,
              userKey: this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || '',
              lang: this.userIdentity?.langKey || JSON.parse(localStorage.getItem('localStorageUser'))?.langKey || 'en',
              documentMetaInfos: documentMetaInfos,
              privateType: this.privacyReport,
              speakers: [
                {
                  speakerId: this.hostAudioSelected.narratorId,
                  speakerNm: this.hostAudioSelected.narratorName,
                  type: 'host',
                  speakerRole: this.hostAudioSelected.narratorPosition,
                },
              ],
              isUpdate: true,
            };
          }
        }

        if (this.listMessageIdsFocus?.length > 0) {
          let tempList = [];

          this.allHistoryMessages.forEach(item => {
            if (item?.messages && Array.isArray(item.messages)) {
              const matchingMessages = item.messages.filter(message => this.listMessageIdsFocus.includes(message.messageId));

              if (matchingMessages.length > 0) {
                tempList.push(...matchingMessages);
              }
            }
          });

          if (tempList?.length > 0) {
            tempList = tempList.map(item => {
              return {
                messageId: item?.messageId || '',
                role: item?.role || '',
                content: item?.content || '',
                messageDate: item?.messageDate || '',
                ragList: item?.ragList?.map(rag => rag.docId) || [],
                like: item?.like || 0,
                isSelected: true,
              };
            });
          }

          if (tempList?.length > 0) {
            objectMessages = [...tempList];
          }
        }

        await this.briefingService()
          .saveBriefingResourceWithBody(
            briefingResources,
            false,
            null,
            SAVE_TYPE_REPORT,
            this.reportTypesResult,
            null,
            this.privacyReport,
            objectMessages,
            this.promptReportFocus,
            this.createAgentTypesForRePort,
            objectPodCast
          )
          .then(response => {
            if (response?.data?.body?.data && response?.data?.body?.data.length > 0 && response?.data?.body?.result === 'success') {
              if (!this.isGenerateBriefingPage) {
                this.$nextTick(() => {
                  this.makeLoadingReportData(loadingDataList, undefined);
                });
              }
            } else {
              // console.log('fail1');
              this.showResponseMessage(`${this.$t('toast.update.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);

              return;
            }
          })
          .catch(err => {
            // console.log('fail2: ', err);
            this.showResponseMessage(`${this.$t('toast.update.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);

            return;
          });
      } catch (e) {
        // console.log('fail3: ', e);
        this.showResponseMessage(`${this.$t('toast.update.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);

        return;
      }

      if (!this.isGenerateBriefingPage) {
        return;
      }
    }

    if (!this.isGenerateBriefingPage) {
      return;
    } else {
      loadingDataList.push({
        type: LOADING_DATA_TYPE.REPORT_BRIEFING.toString(),
        requestId: requestId.concat('_').concat(LOADING_DATA_TYPE.REPORT.toString()),
      });
    }

    // create agent
    const tempTitle = removeUnUsedSpace(this.title || '');
    const tempDescription = removeUnUsedSpace(this.description || '');
    this.LOADING_CREATE.REPORT_BRIEFING = {
      requestId: requestId.concat('_').concat(LOADING_DATA_TYPE.REPORT.toString()),
      isUse: true,
      isLoading: true,
      isSuccess: false,
      isTimeOut: false,
    };

    this.briefingService()
      .createNewBriefing(
        requestId,
        userKey,
        this.$i18n.locale || 'en',
        bpResourceList,
        conversationId,
        tempTitle,
        tempDescription,
        this.privacy,
        this.reportTypesResultForBriefing,
        this.getChatSetting,
        this.createAgentTypes,
        this.connectScrapAgentList,
        this.listMessageIdsFocus,
        this.promptReportFocusForBriefing,
        this.privacyReport
      )
      .then(async res => {
        // console.log(852);
        if (res?.data?.body?.body?.bpId) {
          // console.log(963);
          if (this.getIsCreateNewBriefingFromChat) {
            // console.log('case getIsCreateNewBriefingFromChat');

            const referenceDocuments = JSON.parse(JSON.stringify(this.getReferenceDocuments));
            referenceDocuments.forEach(doc => (doc.targetBpId = res.data.body.body.bpId));
            referenceDocuments.forEach(doc => (doc.requestedResourceList = bpResourceList));

            let tempReferenceDocuments = referenceDocuments.map(item => {
              return convertToBriefingResourceReq(
                item,
                userKey,
                this.$route.name,
                this.getSelectedBriefingPage,
                referenceDocuments,
                this.$i18n.locale,
                lastName,
                requestId,
                true
              );
            });

            tempReferenceDocuments = tempReferenceDocuments.map(({ channel, ...rest }) => rest);

            let tempNotifyResourceItems = this.$store.getters['appStore/getNotifyResourceItem'];
            if (this.$store.getters['appStore/getNotifyResourceItem'].length) {
              tempNotifyResourceItems.forEach(document => {
                document.requestId = 'Notify-' + Date.now().toString();
                document.lang = this.userIdentity?.langKey || JSON.parse(localStorage.getItem('localStorageUser'))?.langKey || 'en';
                document.targetBpId = res.data.body.body.bpId;
                document.userKey = this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
                document.owner_user_key = document?.owner_user_key
                  ? document?.owner_user_key
                  : document?.originParentDocDetail?.owner_user_key
                  ? document?.originParentDocDetail?.owner_user_key
                  : null;
              });
            }

            if (tempNotifyResourceItems?.length > 0) {
              tempNotifyResourceItems = tempNotifyResourceItems.filter(
                item => item?.isBriefingDataNotify === undefined || !item?.isBriefingDataNotify || item?.isBriefingDataNotify === false
              );

              if (tempNotifyResourceItems?.length > 0) {
                await this.briefingService().saveBriefingResource(tempNotifyResourceItems);
              }
            }

            await this.briefingService()
              .saveBriefingResource(tempReferenceDocuments, false)
              .then(async responseSave => {
                if (responseSave.data.body.result === 'success') {
                  await this.saveChatAndMakeLoadingData(res, loadingDataList);
                }
              });
            // } else if (this.getIsForNewBriefing !== undefined && this.getIsForNewBriefing === true) {
          } else {
            // console.log('case getIsForNewBriefing');

            const referenceDocuments = JSON.parse(JSON.stringify(this.getReferenceDocumentsForNewBriefing));

            referenceDocuments.forEach(doc => (doc.targetBpId = res.data.body.body.bpId));
            referenceDocuments.forEach(doc => (doc.requestedResourceList = bpResourceList));

            // console.log('referenceDocuments: ', referenceDocuments);

            let tempReferenceDocuments = referenceDocuments.map(item => {
              return convertToBriefingResourceReq(
                item,
                userKey,
                this.$route.name,
                this.getSelectedBriefingPage,
                referenceDocuments,
                this.$i18n.locale,
                lastName,
                requestId,
                true
              );
            });

            tempReferenceDocuments = tempReferenceDocuments.map(({ channel, ...rest }) => rest);

            await this.briefingService()
              .saveBriefingResource(tempReferenceDocuments, false)
              .then(async responseSave => {
                if (responseSave.data.body.result === 'success') {
                  await this.saveChatAndMakeLoadingData(res, loadingDataList);
                }
              });
          }
          // } else {
          //   console.log('case undefined');
          //
          //   await this.saveChatAndMakeLoadingData(res, undefined);
          // }
        } else {
          // console.log(123);
          this.showResponseMessage(`${this.$t('toast.create.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);
        }
      })
      .catch(error => {
        // console.log(456);
        this.showResponseMessage(`${this.$t('toast.create.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);
      });
  }

  async saveChatAndMakeLoadingData(res, loadingDataInput: LoadingDataByType[]) {
    const tempUserKey = this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
    const tempLangKey = this.userIdentity?.langKey || JSON.parse(localStorage.getItem('localStorageUser'))?.langKey || 'en';

    await this.askGooverService()
      .generateConversationId(
        tempUserKey,
        tempLangKey,
        'briefing',
        res.data.body.body.bpId,
        undefined,
        this.getIsCreateNewBriefingFromChat ? this.getConversationId : '',
        'CC-BP-' + Date.now().toString()
      )
      .then(() => {
        if (loadingDataInput?.length > 0) {
          // add report loading when create briefing
          this.makeLoadingReportData(loadingDataInput, res?.data?.body?.body?.bpId || '');
        }

        this.setIsForNewBriefing(false);
        this.setReferenceDocumentsForNewBriefing([]);
        this.$store.commit('appStore/setNotifyResourceItem', []);
        this.$emit('reloadBriefingPage', true);
      });
  }

  async getListPodcast() {
    const langKey = this.userIdentity?.langKey || JSON.parse(localStorage.getItem('localStorageUser'))?.langKey || 'en';

    try {
      const response = await this.recapService().getListPodcast(langKey);

      this.podcastHosts = response?.body || [];

      // console.log('this.podcastHosts: ', this.podcastHosts);

      if (this.podcastHosts.length > 0) {
        this.hostAudioSelected = this.podcastHosts[0];
        this.loadAudio(this.podcastHosts?.[0].narratorUrlExample);
      }
    } catch (error) {
      console.error('Get podcast error:', error);
    }
  }

  async handleCreateAll() {
    if (this.selectedTab.includes(GOOVER_WIDZAD.CREATE_BRIEFING_AGENT.toString())) {
      this.createAgentTypes.push(GOOVER_WIDZAD.CREATE_BRIEFING_AGENT.toString());
      this.isGenerateBriefingPage = true;
    } else {
      this.isGenerateBriefingPage = false;
    }

    if (this.selectedTab.includes(GOOVER_WIDZAD.CREATE_REPORT.toString())) {
      this.createAgentTypes.push(GOOVER_WIDZAD.CREATE_REPORT.toString());
    }

    if (this.selectedTab.includes(GOOVER_WIDZAD.CREATE_CONNECT_AGENT.toString())) {
      this.createAgentTypes.push(GOOVER_WIDZAD.CREATE_CONNECT_AGENT.toString());
    }

    if (!this.reportTypesResult || this.reportTypesResult?.length === 0) {
      this.reportTypesResult = [this.reportTypes[0]];
    }

    if (!this.reportTypesResultForBriefing || this.reportTypesResultForBriefing?.length === 0) {
      this.reportTypesResultForBriefing = [this.reportTypes[0]];
    }

    this.$emit('reportTypesResult', this.reportTypesResult);
    this.$emit('reportTypesResultForBriefing', this.reportTypesResultForBriefing);

    this.disableButtons();

    await this.saveData().finally(() => {
      this.isLoading = false;
      this.setDisabledLink(false);
    });
  }

  get reportCreatingText(): string {
    if (['DAILY', 'DAILY_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('cdHome.t165') as string;
    } else if (this.reportTypesResult.includes('INDEPTH_DAILY')) {
      return this.$t('cdHome.t165a') as string;
    } else if (['PRODUCT_REVIEW', 'PRODUCT_REVIEW_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('cdHome.t165b') as string;
    } else if (['INVESTMENT', 'INVESTMENT_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('cdHome.t165c') as string;
    } else {
      return '';
    }
  }

  get goToPage(): string {
    if (['DAILY', 'DAILY_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('modal-create-agent.t6General') as string;
    } else if (this.reportTypesResult.includes('INDEPTH_DAILY')) {
      return this.$t('modal-create-agent.t6Indepth') as string;
    } else if (['PRODUCT_REVIEW', 'PRODUCT_REVIEW_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('modal-create-agent.t6Review') as string;
    } else if (['INVESTMENT', 'INVESTMENT_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('modal-create-agent.t6Investment') as string;
    } else {
      return '';
    }
  }

  get isReachLimitCreation(): boolean {
    const { policyUsers } = this.userIdentity;
    if (policyUsers) {
      for (const paidInfo of policyUsers) {
        if (paidInfo.featureIdx == 2) {
          return paidInfo.remain == 0;
        }
      }
    }
    return false;
  }

  async getReportDataForLoading(): Promise<any> {
    return await this.briefingService().getAllMyBriefingData(
      null,
      [DOCUMENT_TYPE_REPORT],
      [CONTENT_TYPE_MY_CONTENT],
      null,
      null,
      null,
      null,
      false,
      false,
      0,
      30
    );
  }

  async getReportBriefingDataForLoading(bpIdInput?: string): Promise<any> {
    return await this.briefingService().getAllMyBriefingData(
      bpIdInput || null,
      [DOCUMENT_TYPE_REPORT],
      [CONTENT_TYPE_MY_CONTENT],
      null,
      null,
      null,
      null,
      false,
      false,
      0,
      30
    );
  }

  async getJournalistNoteDataForLoading(): Promise<any> {
    return await this.briefingService().getAllMyBriefingData(
      null,
      [DOCUMENT_TYPE_REPORT],
      [CONTENT_TYPE_MY_CONTENT],
      null,
      null,
      null,
      null,
      false,
      false,
      0,
      30,
      null,
      [MEDIA_TYPES.JOURNAL_NOTE.toString(), MEDIA_TYPES.JOURNAL_NOTE_BLOG.toString()]
    );
  }

  async getSocialMediaPostingDataForLoading(): Promise<any> {
    return await this.briefingService().getAllMyBriefingData(
      null,
      [DOCUMENT_TYPE_REPORT],
      [CONTENT_TYPE_MY_CONTENT],
      null,
      null,
      null,
      null,
      false,
      false,
      0,
      30,
      null,
      [MEDIA_TYPES.SOCIAL_MEDIA.toString(), MEDIA_TYPES.SOCIAL_MEDIA_BLOG.toString()]
    );
  }

  async getPodcastDataForLoading(requestIdInput: string): Promise<any> {
    return await this.briefingService().callAPIGetPodcastByRequestId(requestIdInput);
  }

  async getScrapAgentList() {
    const userKey = this.$store.getters?.userIdentity?.id
      ? this.$store.getters.userIdentity.id
      : JSON.parse(localStorage.getItem('localStorageUser'))?.id;
    const language = this.$store.getters.currentLanguage;

    if (userKey) {
      await this.briefingService()
        .callAPIGetScrapAgents(userKey, null, 0, 10000, true, [language], null)
        .then(res => {
          if (res?.data?.body?.body?.briefingPageList) {
            this.scrapAgentDataList = res.data.body.body.briefingPageList;
          } else {
            this.scrapAgentDataList = [];
          }
        });
    }
  }

  changeFormDataScrapAgent(data) {
    // console.log('data: ', data)
    this.scrapData = data || null;
    this.checkIsDisableNextForScrapTab();
  }

  makeLoadingReportData(loadingDataListInput: LoadingDataByType[], bpIdInput?: string) {
    loadingDataListInput.forEach(itemLoading => {
      this.startLoadingProcess(itemLoading.type, itemLoading.requestId, bpIdInput);

      const tempBpId =
        itemLoading?.requestId?.includes('CB') || itemLoading.type === LOADING_DATA_TYPE.REPORT_BRIEFING.toString() ? bpIdInput : '' || '';

      // create new loading report data for toast
      const tempToastReportData: ToastReportData = {
        id: '',
        requestId: itemLoading.requestId,
        bpId: tempBpId || '',
        addedTime: new Date().getTime(),
        status: REPORT_TOAST_STATUS.LOADING,
        statusCode: '',
        notifyReportData: '',
        type: this.reportToastUtil.removeLeadingUnderscores(itemLoading.type),
        reportTypesResult: this.reportTypesResult,
        reportTypesResultForBriefing: this.reportTypesResultForBriefing,
        isReShow: false,
      };

      if (this.getToastReportData?.length > 0) {
        this.reportToastUtil.setLoadingDataReportToastListLocalStorage([...this.getToastReportData, tempToastReportData]);

        // console.log('logSetToastReportData_7619483250');
        this.setToastReportData([...this.getToastReportData, tempToastReportData]);
      } else {
        // console.log('logSetToastReportData_5481962370');
        this.reportToastUtil.setLoadingDataReportToastListLocalStorage([tempToastReportData]);
        this.setToastReportData([tempToastReportData]);
      }

      // create new loading report data for card
      if (itemLoading.type !== LOADING_DATA_TYPE.PODCAST.toString()) {
        const loadingDataReportCard: LoadingDataReportCard = {
          id: undefined,
          requestId: itemLoading.requestId,
          bpId: tempBpId || '',
          addedTime: new Date().getTime(),
          type: this.reportToastUtil.removeLeadingUnderscores(itemLoading.type),
        };

        this.loadingReportCardUtil.addLoadingCardToLocalStorage(loadingDataReportCard);
      }
    });
  }

  closeModal(): void {
    this.handleKillAll();

    this.setShowCreateBriefing(false);
  }

  toggleReportType(valueInput: string) {
    setTimeout(() => {
      if (valueInput) {
        let tempReportType = '';

        switch (valueInput) {
          // daily
          case this.reportTypes[0]:
            tempReportType = this.reportStyleSelected === this.optionReportTypes[2] ? this.reportTypes[4] : this.reportTypes[0];
            break;

          // product
          case this.reportTypes[1]:
            tempReportType = this.reportStyleSelected === this.optionReportTypes[2] ? this.reportTypes[5] : this.reportTypes[1];
            break;

          // investment
          case this.reportTypes[2]:
            tempReportType = this.reportStyleSelected === this.optionReportTypes[2] ? this.reportTypes[6] : this.reportTypes[2];
            break;

          // in-depth
          case this.reportTypes[10]:
            tempReportType = this.reportTypes[10];
            this.reportStyleSelected = this.optionReportTypes[1];
            break;
        }

        if (tempReportType) {
          this.reportTypesResult = [tempReportType];
        }

        if (!this.reportStyleSelected || this.reportStyleSelected?.length === 0) {
          this.reportTypesResult = [this.reportTypes[0]];
        }
      }
    }, 10);
  }

  toggleReportTypeForBriefing(valueInput: string) {
    setTimeout(() => {
      if (valueInput) {
        let tempReportType = '';

        switch (valueInput) {
          // daily
          case this.reportTypes[0]:
            tempReportType = this.reportStyleSelectedForBriefing === this.optionReportTypes[2] ? this.reportTypes[4] : this.reportTypes[0];

            break;

          // product
          case this.reportTypes[1]:
            tempReportType = this.reportStyleSelectedForBriefing === this.optionReportTypes[2] ? this.reportTypes[5] : this.reportTypes[1];
            break;

          // investment
          case this.reportTypes[2]:
            tempReportType = this.reportStyleSelectedForBriefing === this.optionReportTypes[2] ? this.reportTypes[6] : this.reportTypes[2];
            break;

          // in-depth
          case this.reportTypes[10]:
            tempReportType = this.reportTypes[10];
            this.reportStyleSelectedForBriefing = this.optionReportTypes[1];

            break;
        }

        if (tempReportType) {
          this.reportTypesResultForBriefing = [tempReportType];
        }

        if (!this.reportTypesResultForBriefing || this.reportTypesResultForBriefing?.length === 0) {
          this.reportTypesResultForBriefing = [this.reportTypes[0]];
        }
      }
    }, 10);
  }

  disableButtons() {
    this.isLoading = true;
    this.setDisabledLink(true);
    setTimeout(() => {
      this.setDisabledLink(false);
    }, 7000);
  }

  handleSelectTab(input) {
    if (this.selectedTab.includes(input)) {
      const index = this.selectedTab.indexOf(input);
      if (index !== -1) {
        this.selectedTab.splice(index, 1);
      }
    } else {
      this.selectedTab.push(input);
    }
    this.selectedTab?.sort((a, b) => this.enumOrder[a] - this.enumOrder[b]);
  }

  nextTab() {
    if (this.currentTab === this.END_TAB) {
      this.closeModal();

      return;
    }

    if (this.currentTab === this.allSelectTab[0]) {
      this.currentTab = this.selectedTab?.[0] || this.ALL;

      return;
    }

    let indexOfSelected = this.selectedTab.indexOf(this.currentTab);
    const indexOfAll = this.allSelectTab.indexOf(this.currentTab);

    if (indexOfSelected !== -1 && indexOfAll !== -1 && indexOfAll < 5) {
      if (this.selectedTab.includes(this.allSelectTab[5])) {
        this.currentTab = this.allSelectTab[5];

        return;
      } else if (this.selectedTab.includes(this.allSelectTab[6])) {
        this.currentTab = this.allSelectTab[6];

        return;
      } else {
        this.currentTab = this.END_TAB;
      }
    }

    if (indexOfSelected === this.selectedTab.length - 1) {
      this.currentTab = this.END_TAB;
    }

    if (this.currentTab === this.END_TAB) {
      this.handleCreateAll();
      return;
    }

    if (indexOfSelected !== -1 && indexOfSelected < this.selectedTab.length - 1) {
      indexOfSelected++;
      this.currentTab = this.selectedTab[indexOfSelected];
    }
  }

  prevTab() {
    if (this.isShowSelectChat) {
      this.isShowSelectChat = false;
      return;
    }

    if (this.currentTab === this.selectedTab?.[0]) {
      this.currentTab = this.ALL;
      return;
    }

    const index = this.selectedTab.indexOf(this.currentTab);

    if (
      this.currentTab === this.allSelectTab[1] ||
      this.currentTab === this.allSelectTab[2] ||
      this.currentTab === this.allSelectTab[3] ||
      this.currentTab === this.allSelectTab[4]
    ) {
      this.currentTab = this.ALL;

      return;
    }

    if (index > 0) {
      this.currentTab = this.selectedTab[index - 1];
    } else {
      this.currentTab = this.ALL;
    }
  }

  changeDataSource(data) {
    event.stopPropagation();
    event.preventDefault();

    // if (data !== DATA_SOURCE_CHAT.BASIC.toString()) {
    //   const isPaid = isPaidUser(true);
    //   if (!isPaid) return;
    // }

    if (!this.dataSource) {
      this.dataSource = [];
    }

    const index = this.dataSource.indexOf(data);

    if (index === -1) {
      this.dataSource.push(data);
    } else {
      this.dataSource.splice(index, 1);
    }
  }

  changeMessageId(data, indexInput) {
    event.stopPropagation();
    event.preventDefault();

    if (!this.tempCheckedListMessageIdsFocus?.includes(data.messageId)) {
      this.tempCheckedListMessageIdsFocus.push(data.messageId);
      if (this.tempListTitleMessage[indexInput + 1] && this.tempListTitleMessage[indexInput + 1].role === ROLE_CHAT.ASSISTANT.toString()) {
        this.tempCheckedListMessageIdsFocus.push(this.tempListTitleMessage[indexInput + 1].messageId);
      }
    } else {
      const index = this.tempCheckedListMessageIdsFocus.indexOf(data.messageId);
      if (index !== -1) {
        this.tempCheckedListMessageIdsFocus.splice(index, 1);
      }

      if (this.tempListTitleMessage[indexInput + 1] && this.tempListTitleMessage[indexInput + 1].role === ROLE_CHAT.ASSISTANT.toString()) {
        const index2 = this.tempCheckedListMessageIdsFocus.indexOf(this.tempListTitleMessage[indexInput + 1].messageId);
        if (index2 !== -1) {
          this.tempCheckedListMessageIdsFocus.splice(index2, 1);
        }
      }
    }
  }

  checkAllChat() {
    event.stopPropagation();
    event.preventDefault();

    if (
      this.tempCheckedListMessageIdsFocus?.length > 0 &&
      this.tempCheckedListMessageIdsFocus.length === this.tempListTitleMessage.length
    ) {
      this.tempCheckedListMessageIdsFocus = [];
    } else {
      this.tempCheckedListMessageIdsFocus = this.tempListTitleMessage.map(item => item.messageId);
    }
  }

  getCurrentStepNumber() {
    if (this.currentTab === this.END_TAB) {
      return this.getTotalSteps();
    }

    let firstGroupStepNumber = 1;
    let secondGroupStepNumber = 0;
    let thirdGroupStepNumber = 0;

    if (
      this.selectedTab.includes(this.allSelectTab[1]) ||
      this.selectedTab.includes(this.allSelectTab[2]) ||
      this.selectedTab.includes(this.allSelectTab[3]) ||
      this.selectedTab.includes(this.allSelectTab[4])
    ) {
      firstGroupStepNumber++;
    }

    // Check for step 2
    if (this.selectedTab.includes(this.allSelectTab[5])) {
      secondGroupStepNumber = firstGroupStepNumber + 1;
    }

    // Check for step 3
    if (this.selectedTab.includes(this.allSelectTab[6])) {
      if (secondGroupStepNumber > 0) {
        thirdGroupStepNumber = secondGroupStepNumber + 1;
      } else {
        thirdGroupStepNumber = firstGroupStepNumber + 1;
      }
    }

    if (
      this.currentTab === this.allSelectTab[1] ||
      this.currentTab === this.allSelectTab[2] ||
      this.currentTab === this.allSelectTab[3] ||
      this.currentTab === this.allSelectTab[4]
    ) {
      return firstGroupStepNumber;
    } else if (this.currentTab === this.allSelectTab[5]) {
      return secondGroupStepNumber;
    } else if (this.currentTab === this.allSelectTab[6]) {
      return thirdGroupStepNumber;
    } else {
      return 0;
    }
  }

  getTotalSteps() {
    let total = 2;

    // Check for step 1
    if (
      this.selectedTab.includes(this.allSelectTab[1]) ||
      this.selectedTab.includes(this.allSelectTab[2]) ||
      this.selectedTab.includes(this.allSelectTab[3]) ||
      this.selectedTab.includes(this.allSelectTab[4])
    ) {
      total++;
    }

    // Check for step 2
    if (this.selectedTab.includes(this.allSelectTab[5])) {
      total++;
    }

    // Check for step 3
    if (this.selectedTab.includes(this.allSelectTab[6])) {
      total++;
    }

    return total;
  }

  onProgressChange(): void {
    this.audio.currentTime = (this.playerProgress / 100) * this.totalTime;
  }

  togglePlay(): void {
    if (this.isPlaying) {
      this.audio.pause();
    } else {
      this.audio.play();
    }
    this.isPlaying = !this.isPlaying;
  }

  toggleMute(): void {
    this.isMuted = !this.isMuted;
    this.audio.muted = this.isMuted;
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }

  loadAudio(url: string): void {
    this.audio.src = url;
    this.audio.load();
    this.audio.onloadedmetadata = () => {
      this.totalTime = this.audio.duration;
    };
    this.audio.ontimeupdate = this.updateProgress;
    this.audio.pause();
    this.isPlaying = false;
  }

  updateProgress(): void {
    this.playerProgress = (this.audio?.currentTime / this.totalTime) * 100 || 0;
    this.currentTime = this.audio?.currentTime || 0;
  }

  handleChangeShowOverText(idInput: number, isShow: boolean) {
    if (isShow) {
      this.noTruncatedIdsList.push(idInput);
      this.truncatedIdsList = this.truncatedIdsList.filter(id => id !== idInput);
    } else {
      this.truncatedIdsList.push(idInput);
      this.noTruncatedIdsList = this.noTruncatedIdsList.filter(id => id !== idInput);
    }
  }

  isTruncated(idInput): boolean {
    const element = document.getElementById(idInput);

    if (element) {
      const isHeightTruncated = element.scrollHeight > element.clientHeight;

      const isWidthTruncated = element.scrollWidth > element.clientWidth;

      return isHeightTruncated || isWidthTruncated;
    } else {
      return false;
    }
  }

  handleConnectScrapAgentList(dataInput: any) {
    this.connectScrapAgentList = dataInput || [];
    this.checkIsDisableNextForScrapTab();
  }

  handleKillAudio() {
    if (this.audio) {
      this.audio.pause();
      this.audio.src = '';
      this.audio = null;
    }
  }

  checkAllItemsComplete() {
    if (
      Object.entries(this.LOADING_CREATE)
        .filter(([key, value]) => key !== this.ALL && value.isUse === true)
        .every(([key, value]) => value.isLoading === false && value.isSuccess === true)
    ) {
      this.LOADING_CREATE.ALL = { isUse: true, isLoading: false, isSuccess: true, isTimeOut: false };
    }
  }

  startLoadingProcess(type: string, requestIdInput?: string, bpIdInput?: string) {
    if (!this.LOADING_CREATE[type].isUse) {
      return;
    }

    if (this.loadingIntervals[type]) {
      clearInterval(this.loadingIntervals[type]);
      this.loadingIntervals[type] = null;
    }

    this.loadingCount[type] = 0;
    this.isDataReceived[type] = false;
    this.LOADING_CREATE[type].isLoading = true;
    this.LOADING_CREATE[type].isSuccess = false;

    this.makeTimeOutAll();

    this.autoCheckAllItemsComplete();

    const loadingFunction = this.getLoadingFunction(type, requestIdInput, bpIdInput);

    if (loadingFunction) {
      loadingFunction()
        .then(response => {
          const hasData = this.processResponseData(type, response, requestIdInput);

          if (hasData) {
            this.isDataReceived[type] = true;
            this.LOADING_CREATE[type].isSuccess = true;
            this.LOADING_CREATE[type].isLoading = false;

            if (this.loadingIntervals[type]) {
              clearInterval(this.loadingIntervals[type]);
              this.loadingIntervals[type] = null;
            }

            this.checkAllItemsComplete();
          }
        })
        .catch(error => {
          console.error(`Error in initial ${type} loading:`, error);
        });

      this.loadingIntervals[type] = setInterval(async () => {
        this.loadingCount[type]++;

        if (this.isDataReceived[type] || this.loadingCount[type] >= this.maxLoadingCount) {
          clearInterval(this.loadingIntervals[type]);
          this.loadingIntervals[type] = null;
          return;
        }

        try {
          const response = await loadingFunction();

          const hasData = this.processResponseData(type, response, requestIdInput);

          if (hasData) {
            this.isDataReceived[type] = true;
            this.LOADING_CREATE[type].isSuccess = true;
            this.LOADING_CREATE[type].isLoading = false;

            clearInterval(this.loadingIntervals[type]);
            this.loadingIntervals[type] = null;

            this.checkAllItemsComplete();
          }
        } catch (error) {
          console.error(`Error in ${type} loading interval:`, error);
        }
      }, 10000);
    }
  }

  getLoadingFunction(type: string, requestIdInput?: string, bpIdInput?: string): (() => Promise<any>) | null {
    switch (type) {
      case LOADING_DATA_TYPE.REPORT.toString():
        return () => this.getReportDataForLoading();

      case LOADING_DATA_TYPE.JOURNALIST_NOTE.toString():
        return () => this.getJournalistNoteDataForLoading();

      case LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString():
        return () => this.getSocialMediaPostingDataForLoading();

      case LOADING_DATA_TYPE.PODCAST.toString():
        return () => this.getPodcastDataForLoading(requestIdInput?.replace('_' + type, ''));

      case LOADING_DATA_TYPE.REPORT_BRIEFING.toString():
        return () => this.getReportBriefingDataForLoading(bpIdInput);

      default:
        return null;
    }
  }

  processResponseData(type: string, response: any, requestIdInput: string): boolean {
    if (!response || !response.data) {
      return false;
    }

    let tempList = [];
    let result = false;

    switch (type) {
      case LOADING_DATA_TYPE.REPORT.toString():
        tempList = response?.data?.body?.body?.discoveryReportDTO?.listBriefingData || [];

        if (tempList?.length > 0) {
          tempList.forEach(item => {
            const tempItemRequestId = item?.parentDocDetail?.request_id || item?.requestId || '';

            if (
              tempItemRequestId &&
              tempItemRequestId.concat(this.loadingReportCardUtil.makeConcatStringByMediaType(item)) === requestIdInput
            ) {
              this.reportToastUtil.handleRemoveLoadingReportToastWithListInput([item]);
              this.replaceLoadingToastBySuccessToastData(item);

              result = true;
            }
          });
        }

        return result;

      case LOADING_DATA_TYPE.JOURNALIST_NOTE.toString():
        tempList = response?.data?.body?.body?.discoveryReportDTO?.listBriefingData || [];

        if (tempList?.length > 0) {
          tempList.forEach(item => {
            const tempItemRequestId = item?.parentDocDetail?.request_id || item?.requestId || '';

            if (
              tempItemRequestId &&
              tempItemRequestId.concat(this.loadingReportCardUtil.makeConcatStringByMediaType(item)) === requestIdInput
            ) {
              this.reportToastUtil.handleRemoveLoadingReportToastWithListInput([item]);
              this.replaceLoadingToastBySuccessToastData(item);

              result = true;
            }
          });
        }

        return result;

      case LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString():
        tempList = response?.data?.body?.body?.discoveryReportDTO?.listBriefingData || [];

        if (tempList?.length > 0) {
          tempList.forEach(item => {
            const tempItemRequestId = item?.parentDocDetail?.request_id || item?.requestId || '';

            if (
              tempItemRequestId &&
              tempItemRequestId.concat(this.loadingReportCardUtil.makeConcatStringByMediaType(item)) === requestIdInput
            ) {
              this.reportToastUtil.handleRemoveLoadingReportToastWithListInput([item]);
              this.replaceLoadingToastBySuccessToastData(item);

              result = true;
            }
          });
        }

        return result;

      case LOADING_DATA_TYPE.PODCAST.toString():
        result = response?.data?.body?.body?.isSuccess || false;

        if (result) {
          this.replaceLoadingToastBySuccessToastData(undefined, { requestId: requestIdInput, type: type });
        }

        return result;

      case LOADING_DATA_TYPE.REPORT_BRIEFING.toString():
        tempList = response?.data?.body?.body?.discoveryReportDTO?.listBriefingData || [];

        if (tempList?.length > 0) {
          tempList.forEach(item => {
            const tempItemRequestId = item?.parentDocDetail?.request_id || item?.requestId || '';

            if (
              tempItemRequestId &&
              tempItemRequestId.concat(this.loadingReportCardUtil.makeConcatStringByMediaType(item)) === requestIdInput
            ) {
              this.reportToastUtil.handleRemoveLoadingReportToastWithListInput([item]);
              this.replaceLoadingToastBySuccessToastData(item);

              result = true;
            }
          });
        }

        return result;

      default:
        return false;
    }
  }

  killLoading() {
    if (this.loadingIntervals) {
      Object.keys(this.loadingIntervals).forEach(key => {
        if (this.loadingIntervals[key]) {
          clearInterval(this.loadingIntervals[key]);
          this.loadingIntervals[key] = null;
        }
      });
    }
  }

  handleRemoveLoadingToast() {
    try {
      const tempList = [];

      Object.keys(this.LOADING_CREATE).forEach(key => {
        if (this.LOADING_CREATE[key] && this.LOADING_CREATE[key].requestId) {
          tempList.push(this.LOADING_CREATE[key].requestId);
        }
      });

      if (tempList?.length > 0) {
        this.handleRemoveToastReportDataByListRequestIds(tempList);
        this.$emit('handleRemoveToastReportDataByListRequestIds', tempList);
      }

      setTimeout(() => {
        this.closeModal();
      }, 100);
    } catch (error) {
      this.closeModal();
    }
  }

  markDoneCreateScrapAgent() {
    this.LOADING_CREATE.SCRAP_AGENT = { isUse: true, isLoading: false, isSuccess: true, isTimeOut: false };
    this.checkAllItemsComplete();
  }

  changeHostAudioSelected(data) {
    this.hostAudioSelected = data;
    this.loadAudio(data.narratorUrlExample);
  }

  showResponseMessage(mess, title, variant, hideDelay) {
    this.$bvToast.toast(mess, {
      toaster: 'b-toaster-bottom-right',
      title: title,
      variant: variant,
      solid: true,
      autoHideDelay: hideDelay,
    });
  }

  replaceLoadingToastBySuccessToastData(reportData: any, otherData?: any) {
    let tempListReportNotify = [];
    let tempToastReportData: ToastReportData = {
      id: '',
      requestId: '',
      bpId: '',
      addedTime: 0,
      status: '',
      statusCode: '',
      notifyReportData: undefined,
      isReShow: false,
      type: undefined,
    };

    if (reportData) {
      tempListReportNotify = [reportData]
        ?.filter(item => item?.parentDocDetail && (item?.requestId || item?.parentDocDetail?.request_id))
        ?.map(item => ({
          ...item,
          requestId: item?.requestId || item?.parentDocDetail?.request_id || '',
        }))
        ?.filter(item => item.requestId !== undefined && item.requestId !== null && item.requestId !== '');

      if (tempListReportNotify?.length > 0) {
        // console.log('tempListReportNotify: ', tempListReportNotify);

        const typeString = this.loadingReportCardUtil.makeConcatStringByMediaType(tempListReportNotify?.[0]);

        tempToastReportData = {
          id: tempListReportNotify?.[0]?.parentDocDetail?.parent_doc_id?.[0] || '',
          requestId: tempListReportNotify?.[0]?.requestId.concat(typeString) || '',
          bpId: tempListReportNotify?.[0]?.briefing_page_id || tempListReportNotify?.[0]?.parentDocDetail?.briefing_page_id?.[0] || '',
          addedTime: new Date().getTime(),
          status: REPORT_TOAST_STATUS.SUCCESS,
          statusCode: REPORT_TOAST_STATUS_CODE.SUCCESS,
          notifyReportData: tempListReportNotify?.[0] ? map2ResourceItem(tempListReportNotify?.[0]) : '',
          isReShow: false,
          type: this.reportToastUtil.removeLeadingUnderscores(typeString),
        };
      }

      if (tempToastReportData && tempToastReportData.requestId !== undefined && tempToastReportData.requestId !== '') {
        this.updateToastData(tempToastReportData);
        this.loadingReportCardUtil.handleRemoveLoadingCardByNotifyDataOrAPIData([tempToastReportData.requestId]);
        this.autoRemoveToastReport(tempToastReportData?.requestId || '');
      }
    } else if (otherData) {
      // console.log('otherData: ', otherData);
      tempToastReportData = {
        id: '',
        requestId: otherData.requestId || '',
        bpId: '',
        addedTime: new Date().getTime(),
        status: REPORT_TOAST_STATUS.SUCCESS,
        statusCode: REPORT_TOAST_STATUS_CODE.SUCCESS,
        notifyReportData: '',
        isReShow: false,
        type: otherData.type,
      };

      this.updateToastData(tempToastReportData);
      this.loadingReportCardUtil.handleRemoveLoadingCardByNotifyDataOrAPIData([tempToastReportData.requestId]);
      this.autoRemoveToastReport(tempToastReportData?.requestId || '');
    }
  }

  autoRemoveToastReport(requestIdInput: string) {
    setTimeout(() => {
      this.handleRemoveToastReportDataByRequestId(requestIdInput || '');
    }, TIME_DISPLAY_SUCCESS_TOAST_REPORT);
  }

  handleRemoveToastReportDataByRequestId(requestIdInput: string) {
    if (requestIdInput?.trim()?.length > 0) {
      if (this.getToastReportData?.length > 0) {
        const tempList = this.getToastReportData?.filter(item => item?.requestId !== requestIdInput) || [];

        if (tempList?.length > 0) {
          this.reportToastUtil.setLoadingDataReportToastListLocalStorage(tempList);
          // console.log('logSetToastReportData_4028963751');
          this.setToastReportData(tempList);
        } else {
          // console.log('logSetToastReportData_8765241039');
          this.reportToastUtil.setLoadingDataReportToastListLocalStorage([]);
          this.setToastReportData([]);
        }

        let retryCount = 0;
        const maxRetries = 50;

        const checkAndRetry = () => {
          const isOnState = this.getToastReportData?.some(item => item?.requestId === requestIdInput) || false;
          let isOnLocal = false;

          const tempData = this.reportToastUtil.getLoadingDataReportToastListLocalStorage();
          if (tempData?.length > 0) {
            try {
              const parsedData = JSON.parse(tempData);
              isOnLocal = parsedData?.some?.(item => item?.requestId === requestIdInput) || false;
            } catch (error) {
              isOnLocal = false;
            }
          }

          if (!isOnState && !isOnLocal) {
            return;
          }

          retryCount++;

          if (retryCount < maxRetries) {
            setTimeout(checkAndRetry, 100);
          }
        };

        setTimeout(checkAndRetry, 100);
      }
    }
  }

  handleRemoveToastReportDataByListRequestIds(requestIdsInput: string[]) {
    if (requestIdsInput?.length > 0) {
      if (this.getToastReportData?.length > 0) {
        const tempList = this.getToastReportData?.filter(item => !requestIdsInput?.includes(item?.requestId)) || [];

        if (tempList?.length > 0) {
          // console.log('logSetToastReportData_1294687503');

          this.reportToastUtil.setLoadingDataReportToastListLocalStorage(tempList);
          this.setToastReportData(tempList);
        } else {
          // console.log('logSetToastReportData_6753802914');

          this.reportToastUtil.setLoadingDataReportToastListLocalStorage([]);
          this.setToastReportData([]);
        }

        let retryCount = 0;
        const maxRetries = 50;

        const checkAndRetry = () => {
          const isOnState = this.getToastReportData?.some(item => requestIdsInput?.includes(item?.requestId)) || false;
          let isOnLocal = false;
          const tempData = this.reportToastUtil.getLoadingDataReportToastListLocalStorage();

          if (tempData?.length > 0) {
            try {
              const parsedData = JSON.parse(tempData);
              isOnLocal = parsedData?.some(item => requestIdsInput?.includes(item?.requestId)) || false;
            } catch (error) {
              isOnLocal = false;
            }
          }

          if (!isOnState && !isOnLocal) {
            return;
          }

          retryCount++;

          if (retryCount < maxRetries) {
            setTimeout(checkAndRetry, 100);
          }
        };

        setTimeout(checkAndRetry, 100);
      }
    }
  }

  updateToastData(toastReportDataInput: ToastReportData) {
    if (this.getToastReportData?.length > 0) {
      let isExisted = false;

      const tempList = this.getToastReportData?.map(item => {
        if (item?.requestId === toastReportDataInput?.requestId) {
          isExisted = true;

          const tempBpId =
            toastReportDataInput?.bpId?.length > 0 ? toastReportDataInput?.bpId : (item?.bpId?.length > 0 ? item?.bpId : '') || '';

          toastReportDataInput.bpId = tempBpId || '';

          return toastReportDataInput;
        } else {
          return item;
        }
      });

      if (tempList?.length > 0) {
        if (isExisted) {
          this.reportToastUtil.setLoadingDataReportToastListLocalStorage([...tempList]);

          // console.log('logSetToastReportData_3927450618');
          this.setToastReportData([...tempList]);
        } else {
          // console.log('logSetToastReportData_9013624758');
          this.reportToastUtil.setLoadingDataReportToastListLocalStorage([toastReportDataInput, ...tempList]);
          this.setToastReportData([toastReportDataInput, ...tempList]);
        }
      }
    } else {
      // console.log('logSetToastReportData_5840176293');

      this.reportToastUtil.setLoadingDataReportToastListLocalStorage([toastReportDataInput]);
      this.setToastReportData([toastReportDataInput]);
    }
  }

  goToListPage(page: string) {
    let target = '/my-create/report';

    switch (page) {
      case LOADING_DATA_TYPE.REPORT.toString():
        target = '/my-create/report';
        break;
      case LOADING_DATA_TYPE.JOURNALIST_NOTE.toString():
        target = '/my-create/journalist-note';
        break;
      case LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString():
        target = '/my-create/social-media-posting';
        break;
      case LOADING_DATA_TYPE.PODCAST.toString():
        target = '/my-create/podcast';
        break;
      case LOADING_DATA_TYPE.BRIEFING_AGENT.toString():
        target = '/my-briefing';
        break;
      case LOADING_DATA_TYPE.CONNECT_AGENT.toString():
        target = '/scrap-agent';
        break;
      default:
        target = '/my-create/report';
        break;
    }

    window.location.href = target;
  }

  makeTimeOutAll() {
    if (this.timeOutAll) {
      clearTimeout(this.timeOutAll);
      this.timeOutAll = null;
    }

    this.timeOutAll = setTimeout(() => {
      const itemsToTimeout = Object.entries(this.LOADING_CREATE).filter(
        ([key, value]) => key !== this.ALL && value.isUse === true && value.isLoading === true && value.isSuccess === false
      );

      if (itemsToTimeout.length > 0) {
        itemsToTimeout.forEach(([key, value]) => {
          this.LOADING_CREATE[key].isTimeOut = true;
        });

        this.LOADING_CREATE.ALL.isTimeOut = true;
      }
    }, TIME_OUT_ALL_LOADING_CREATE);
  }

  autoCheckAllItemsComplete() {
    this.stopCheckAllItemsComplete();

    this.checkAllItemsCompleteInterval = setInterval(() => {
      this.checkAllItemsComplete();

      if (this.LOADING_CREATE.ALL.isSuccess === true) {
        this.stopCheckAllItemsComplete();
      }
    }, 1000);
  }

  stopCheckAllItemsComplete() {
    if (this.checkAllItemsCompleteInterval !== null) {
      clearInterval(this.checkAllItemsCompleteInterval);
      this.checkAllItemsCompleteInterval = null;
    }
  }

  checkIsDisableNextForScrapTab() {
    if (this.currentTab === this.allSelectTab[6]) {
      // console.log('this.connectScrapAgentList: ', this.connectScrapAgentList);
      // console.log('this.scrapData: ', this.scrapData);

      setTimeout(() => {
        this.isDisableByScrapModal =
          this.connectScrapAgentList?.length > 0
            ? false
            : this.scrapData
            ? !this.scrapData.briefingTitle ||
              !this.scrapData.dataSourceAccount ||
              this.scrapData.dataSourceAccount?.length === 0 ||
              !this.scrapData.dataSourceAccount.some(account => account.dataSources.some(dataSource => dataSource.isScrap === true))
            : true;
      }, 10);
    }
  }

  get maxPage(): number {
    return Math.ceil(this.podcastHosts.length / this.hostsPerPage) - 1;
  }

  nextPage(): void {
    if (this.currentPage < this.maxPage) {
      this.currentPage++;
    }
  }

  prevPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  get displayedHosts() {
    const start = this.currentPage * this.hostsPerPage;
    return this.podcastHosts.slice(start, start + this.hostsPerPage);
  }

  handleBackMenuAndSaveCheckedChat() {
    this.listMessageIdsFocus = [...this.tempCheckedListMessageIdsFocus];
    this.isShowSelectChat = false;
  }

  handleBackMenuAndResetCheckedChat() {
    this.tempCheckedListMessageIdsFocus = [...this.listMessageIdsFocus];
    this.isShowSelectChat = false;
  }

  handleKillAll() {
    this.handleKillAudio();

    this.killLoading();

    this.stopCheckAllItemsComplete();

    this.setIsForNewBriefing(false);

    this.setReferenceDocumentsForNewBriefing([]);
  }

  validateAndChangePrivacy(event, newValue) {
    if (isPaidUser(true)) {
      this.privacy = newValue;
    } else {
      event.preventDefault();
      event.stopPropagation();

      this.$nextTick(() => {
        event.target.checked = this.privacy === newValue;
      });
    }
  }

  validateAndChangePrivacyForReport(event, newValue) {
    if (isPaidUser(true)) {
      this.privacyReport = newValue;
    } else {
      event.preventDefault();
      event.stopPropagation();

      this.$nextTick(() => {
        event.target.checked = this.privacyReport === newValue;
      });
    }
  }

  scrollToTop() {
    try {
      const modalInnerElement = document.querySelector('.go-modal-inner') as HTMLElement;

      if (modalInnerElement) {
        modalInnerElement.scrollTop = 0;
      }
    } catch (error) {
      // todo
    }
  }
}
